export const dataLists = [
  {
    title: "Go Easy Shop",
    description:
      "Living in a metro city, I was curious about how online grocery services work. This inspired me to create my first project, an e-commerce site called 'Go Easy Shop,' focused on fruits and vegetables",
    image: "/images/ecommerse.png",
    link : "/goeasy",
    liveLink :"https://goeasyshop.in/",
    git : "https://github.com/AnsaAli/Project-01"
  },
  {
    title: "Be-Creative DIY",
    description:
      "This is a modern, fully responsive e-commerce frontend built using React and Vite. The project includes key pages such as Home, View Product, and Cart, ensuring a smooth and user-friendly shopping experience across all devices.",
    image: "/images/art.png",
     link : "/projects",
     liveLink :"https://hobby-art-fronend-5trh8dgyz-ansaalis-projects.vercel.app/",
     git : "https://github.com/AnsaAli/hobby-art"
  },
  {
    title: "OLX Clone",
    description:
      "OLX is one of the most useful websites available, allowing people to buy, sell, and access a variety of services. I’ve created a clone website where users can add products to sell and browse items listed by others, bringing a similar experience to the original platform.",
    image: "/images/olx.png",
     link : "/projects",
     liveLink :"https://github.com/AnsaAli/OLX-with-useContext-API",
     git : "https://github.com/AnsaAli/OLX-with-useContext-API"
  },
  {
    title: "Netflix Clone",
    description:
      "In this project, I recreated Netflix’s interface, featuring movie scraping from Netflix’s inspect page, a login and signup system, movie category browsing, video playback through iframes, and reusable UI components. The site also utilizes efficient routing with React Router, providing a seamless user experience.",
    image: "/images/netflix.png",
     link : "/projects",
     liveLink :"https://github.com/AnsaAli/Netflix",
     git : "https://github.com/AnsaAli/Netflix"
  },
  {
    title: "In Peace - UX/UI",
    description:
      "Anger management is key to a successful life. In Peace is my new innovative idea to positively use technology to control anger in day to day life and there by to be in-peace always.",
    image: "/images/inpeace.png",
     link : "/inpeace",
     liveLink :  "https://xd.adobe.com/view/ed4a86da-a6de-4b1c-85ba-f3de361cfd01-b819/",
     git :    "https://xd.adobe.com/view/ed4a86da-a6de-4b1c-85ba-f3de361cfd01-b819/"
  },
  {
    title: "FoodTube - UX/UI",
    description:
      "Have you ever wondered if there’s an easy way to find all the eateries with unique flavors reviewed by your favorite food vlogger? Yes, there is! I’m excited to introduce you to my new 'FoodTube' application, here to help you explore just that.",
    image: "/images/foodtube.png",
     link : "/foodTube",
     liveLink :"https://xd.adobe.com/view/4e893ab3-779b-4212-9ad1-8caa00bf44f5-1bda/",
     git : "https://xd.adobe.com/view/4e893ab3-779b-4212-9ad1-8caa00bf44f5-1bda/"
  },
  {
    title: "Easy Traveler - UX/UI",
    description:
      "Let me simplify your holiday planning! Search destinations by weather, route, carrier, or adventure activity. Create a virtual room with friends to gather suggestions, run polls, and make travel decisions—all in one place.",
    image: "/images/easyTravel.png",
     link : "/easyTravel",
     liveLink :"https://xd.adobe.com/view/58f05efd-4406-4f67-a1e0-0900baf34289-0da3/",
     git : "https://xd.adobe.com/view/58f05efd-4406-4f67-a1e0-0900baf34289-0da3/"
  },
];
